import React from "react";
import { DataTable, LineChart } from "react-library";
import { TDataset, TTableData } from "../types";
import { TVisualization } from "./ChartOptionsIcons";
import { t } from "../../../services/locale.service";

type TProps = {
  datasets: Array<TDataset>;
  chartId: string;
  timestamps: Array<string>;
  tableColumns: Array<string>;
  active: TVisualization;
  tableData: TTableData
  isLoadingData?: boolean;
}




const DataVisualizationRenderer: React.FC<TProps> = (props) => {
  const { datasets, chartId, timestamps, active, tableData, tableColumns, isLoadingData } = props;
  return (
    < >
      {
        isLoadingData ? 
          <p style={{textAlign: "center"}}>{t("Loading")}</p> : 
          active === "graph"  ?
            datasets.length > 0 && timestamps.length ? (
              <LineChart
                key={chartId}
                datasets={datasets}
                labels={timestamps}
              
              />
            ) : <p style={{textAlign: "center"}}>{t("No_Data_Found")}</p>
            : 
            <DataTable 
              columns={tableColumns}
              data={tableData}
              columnWidths={[80,80,80]}
            />
      }

    </ >
  );
};

export default DataVisualizationRenderer;